jQuery(document).ready(function($) {

  //mobile menu
  $('#header .navigation .menu').click(function() {
    if($(this).find('.fa-bars').length > 0) {
      $('html').addClass('show-nav');
      $(this).find('.fa-bars').removeClass('fa-bars').addClass('fa-times');
    } else {
      $('html').removeClass('show-nav');
      $(this).find('.fa-times').removeClass('fa-times').addClass('fa-bars');
    }
  });    
  
  
  //Thumbnail Image Zoom
  $( "#product-info .thumbnail-img" ).click(function() {    
    $("#product-info .product-image").attr('data-zoom', $(this).data('zoom-img'));
    $("#product-info .product-image .zoom").attr('src', $(this).data('zoom-img'));   
    $("#product-info .product-image .main").attr('src', $(this).data('large-img'));       
  });
  
  
  
  
  
  //product quantity
  $('#product-info .quantity button').click(function() {
    var qty = $('#product-info .quantity input').val();
    if($(this).find('.fa-minus').length > 0) {
      qty = (qty > 1 ? qty-1 : 1); 
    } else {
      qty++;
    }
    $('#product-info .quantity input').val(qty)
  });
  
  //product pricing
  $('#product-info form [name="id"]').change(function() {
    $('#product-info .price .prc').html($(this).find('option:selected').data('price'));
    
    //update selected variant media image
    var thumb = $('#product-info .product-media .product-image-thumbnail [data-variant-id="'+$(this).find('option:selected').val()+'"]');
    if(thumb.length > 0) {
      thumb.click();
    }
    
  }).change();
  
  $('#product-info form [name="properties[Name]"], #product-info form [name="properties[Phone]"]').keyup(function() {
    var extras = "$0.00";
    if($('#product-info form [name="properties[Name]"]').val() && $('#product-info form [name="properties[Phone]"]').val()) {
    	extras = "$" + (parseFloat($('#product-info form [name="properties[Phone]"]').data('price')) + parseFloat($('#product-info form [name="properties[Name]"]').data('price'))).toFixed(2);
    }
    else if($('#product-info form [name="properties[Name]"]').val()) {
      extras = "$" + $('#product-info form [name="properties[Name]"]').data('price');
    }
    else if($('#product-info form [name="properties[Phone]"]').val()) {
      extras = "$" + $('#product-info form [name="properties[Phone]"]').data('price');
    }
    $('#product-info .price .ext').html(extras);  
  }).keyup();  
  
  //clear unused addons
  if($('#cart tr.hasaddon').length == 0 && $('#cart tr.addon').length > 0) {
    $.each($('#cart tr .addon-title'), function(i,v) {
    	changeCartItem($(v), 0);
    });    
  }
  
  //update cart quantity
  $('#cart .cart-quantity-update').click(function() {
    var qty = $(this).parents('tr').find('[name="updates[]"]').val();
    if($.isNumeric(qty)) {      	
      if(qty == 0) {
      	changeCartItem($(this), 0);
      }
      else {
      	changeCartItem($(this), qty);
      }    	
    }  	
  });
  
  //product remove from cart
  $('#cart .cart-remove-button').click(function() {
    changeCartItem($(this), 0);
  });  
  
  function changeCartItem(item, qty) {
    
    var product = item.parents('tr');    
    
    $.post({ url: '/cart/change.js', data: { 'line': (product.index()+1), 'quantity': qty }, dataType: "json" }).done(function() {

      var addon = item.parents('tr.hasaddon').next('tr.addon');
      if(addon.length > 0) {       
        
        $.post({ url: '/cart/change.js', data: { 'line': addon.index(), 'quantity': qty }, dataType: "json" }).done(function() {
          refreshCart();
        })
        .fail(function(e) {
          console.log(e);
          alert("Failed to update cart addon. Please try again.");      
          refreshCart();
        });
      } 
      else {
        refreshCart();
      }
    })
    .fail(function(e) {
      console.log(e);
      alert("Failed to update cart item. Please try again.");      
      refreshCart();
    });  
  }
  
  function updateCartItem(item, qty) {
    var products = [item.parents('tr').data('id')];
    var addon = item.parents('tr.hasaddon').next('tr.addon');
    if(addon.length > 0) {
      products.push(addon.data('id'));  
    }
    
    var data = { updates: {} };
    for (i = 0; i < products.length; i++) {
       data.updates[products[i]] = qty;
    }
    
    $.post({ url: '/cart/update.js', data: data, dataType: "json" }).done(function() {
      refreshCart();
    })
    .fail(function(e) {
      console.log(e);
      alert("Failed to update cart item. Please try again.");      
      refreshCart();
    });  
  }
  
  function refreshCart() {
    $("#cart").css('opacity','0.5');
    location.href = "/cart";
  }

  //product add to cart
  if($('#product-info .customize-collar').length > 0) {
    
    $('#product-info form').submit(function(e) {
      
      var form = $(this);
      
      if(form.data('valid') == 'true') {
        form.data('valid', 'false');  
        return true;
      } else {
        e.preventDefault();
      }            	  
      
      if(!$('#product-info form [name="properties[Name]"]').val() && !$('#product-info form [name="properties[Phone]"]').val()) {
        $('#product-info form [name="properties[Thread Color]"]').val("");
        $('#product-info form [name="properties[Thread Color]"]').parent().find('.error').remove();
      }
      
      if(!$('#product-info form [name="properties[Thread Color]"]').val() && ($('#product-info form [name="properties[Name]"]').val() || $('#product-info form [name="properties[Phone]"]').val())) {
        $('#product-info form [name="properties[Thread Color]"]').parent().append('<div class="error">Required.</div>');
      } else {       
        var addon = null;
        if($('#product-info form [name="properties[Name]"]').val() && $('#product-info form [name="properties[Phone]"]').val()) {
          addon = 37810979340463;
        }
        else if($('#product-info form [name="properties[Name]"]').val()) {
          addon = 37810979274927;
        }
        else if($('#product-info form [name="properties[Phone]"]').val()) {
          addon = 37810979307695;
        }   
        
        if(addon) {
          addCartAddon(addon, form).done(function() {            
            form.data('valid', 'true').submit();
          })
          .fail(function() {
            alert("Failed to add custom embroidery. Please try again.");
          });
        }
        else {
          form.data('valid', 'true').submit();
        }
      }
           
      return false;
    });
  }
  
  function addCartAddon(id, form) {
    var qty = form.find('[name="quantity"]').val();    
    return $.post({ url: '/cart/add.js', data: {
      items: [
        {
          quantity: qty,
          id: id,
          properties: {
            'SKU': $('#product-info form [name="id"] option:selected').data('sku'),
            'Name': $('#product-info form [name="properties[Name]"]').val(),
            'Phone': $('#product-info form [name="properties[Phone]"]').val(),
            'Thread Color': $('#product-info form [name="properties[Thread Color]"]').val(),
            'Notes': $('#product-info form [name="properties[Notes]"]').val()
          }
        }
      ]
    }, 
	dataType: "json" }); 
  }
  
  //color example tool
  $('#product-info .select-boxes select').change(function() {
    $('#product-info .product-left-text-box .scout').css($(this).attr('name'),$(this).val());   
  });
  
  //color example modal
  var modalTemplate = '<div id="modal"><div class="frame">{{content}}<i class="fal fa-times close"></i></div></div>';
  
  $('#product-info  .thread-color-titles [data-url]').click(function() {
    var img = '<img src="'+$(this).data('url')+'" />';
    $('body').append(modalTemplate.replace('{{content}}',img));
  });
  
  $('body').on('click','#modal .close', function() {
  	$('#modal').remove();
  });
  
  //image zoom
  $('#product-info .product-image').hover(
    function() {
      if($(this).find('img.zoom').length == 0) {
      	$(this).append('<img class="zoom show" src="'+$(this).data('zoom')+'" />');  
      }                  
      $(this).find('img.zoom').addClass('show');
  	}, 
	function() {
    	$(this).find('img.zoom').removeClass('show');
  	}
  );
  
  $('#product-info .product-image').mousemove(function( e ) {
    var pointY = e.pageY - $(this).offset().top;
    var pointX = e.pageX - $(this).offset().left;
    var increaseX = $(this).find('img.zoom').width() / $(this).width();
    var increaseY = $(this).find('img.zoom').height() / $(this).height();
    var width = $(this).width() * increaseX;
    var height = $(this).height() * increaseY;
    var left = pointY / height * -100;
    var top = pointX / width * -100;    
    $(this).find('img.zoom').css('width', ($(this).width() * 2) + 'px').css('transform','translate('+top+'%, '+left+'%)');
  });

});